<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <div>
        <mwp-card-resource [resources]="resources" [displayCategroyColumn]="false" [displayCarrierColumn]="false" header="Compliance Resources" />
    </div>
</div>